// eslint-disable-next-line no-unused-vars -- used when enabling registerGlobalErrorHandlers() below
import { registerGlobalErrorHandlers } from "./utils/globalErrorHandler";
import { initializePayloadTrimming } from "./utils/payloadTrim";
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter as Router } from "react-router-dom";
import { ReactFlowProvider } from "react-flow-renderer";

import "./index.css";
import "./App.css";
import { store, persistor } from "./Store/Store";
import ErrorBoundary from "./componets/Common/ErrorBoundary";
import { ThreeDots } from "react-loader-spinner";

registerGlobalErrorHandlers();
const App = lazy(() => import("./App"));

initializePayloadTrimming();

if (process.env.NODE_ENV !== "production" && typeof window !== "undefined") {
  const targetPattern = /SES Removing unpermitted intrinsics|unpermitted intrinsics/i;
  const methods = ["log", "warn", "error"];

  methods.forEach((method) => {
    const originalMethod = console[method];
    if (typeof originalMethod !== "function") return;

    console[method] = function patchedConsoleMethod(...args) {
      try {
        const joined = args
          .map((item) => (typeof item === "string" ? item : ""))
          .join(" ");
        if (targetPattern.test(joined)) {
          originalMethod.call(
            console,
            "[SES TRACE] Captured SES message:",
            ...args
          );
          originalMethod.call(
            console,
            "[SES TRACE] Stack at log interception:\n",
            new Error("SES trace marker").stack
          );
        }
      } catch (traceError) {
        // Keep app logging resilient even if tracing fails.
      }

      return originalMethod.apply(console, args);
    };
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-screen">
          <ThreeDots color="#1995d2" width="50" visible={true} />
        </div>
      }
    >
      <ReactFlowProvider>
        <Provider store={store}>
          <PersistGate loading={<p>Loading...</p>} persistor={persistor}>
            <Router>
              <App />
             
            </Router>
          </PersistGate>
        </Provider>
      </ReactFlowProvider>
    </Suspense>
  </ErrorBoundary>
);
